import type { Entity } from '@backstage/catalog-model';

/**
 * The name the portal shows for an entity: its title, else — for a team read
 * from the GitHub organisation (DX-202), which names itself in its profile
 * rather than in a title — its display name, else its catalog name.
 *
 * For a rendered name from a reference alone, Backstage's own
 * `EntityDisplayName` reads the same three, through the presentation API.
 */
export function entityLabel(entity: Entity): string {
  if (entity.metadata.title) return entity.metadata.title;
  const profile = entity.spec?.profile as { displayName?: unknown } | undefined;
  return typeof profile?.displayName === 'string' && profile.displayName
    ? profile.displayName
    : entity.metadata.name;
}
